module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-row', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.getScreenSize < 2 && !_vm.delayedLoading[10]),
      expression: "getScreenSize < 2 && !delayedLoading[10]"
    }],
    attrs: {
      "span": "24",
      "element-loading-text": "Loading..."
    }
  }, [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    ref: "form",
    attrs: {
      "label-position": "top"
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 25
    }
  }, [(_vm.getScreenSize > 1 || _vm.delayedLoading[0]) ? _c('el-col', {
    attrs: {
      "lg": 12
    }
  }, [_c('el-form-item', {
    staticClass: "el-form-item-full",
    attrs: {
      "label": _vm.$l('settings/interface/Realtime display')
    }
  }, [_c('el-time-picker', {
    attrs: {
      "picker-options": {
        selectableRange: '00:00:00 - 01:00:00'
      }
    },
    model: {
      value: (_vm.getSettingsInterface.rtvaluesPicker),
      callback: function($$v) {
        _vm.$set(_vm.getSettingsInterface, "rtvaluesPicker", $$v)
      },
      expression: "getSettingsInterface.rtvaluesPicker"
    }
  }), _vm._v(" "), _c('el-input', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }],
    model: {
      value: (_vm.getSettingsInterface.rtvalues),
      callback: function($$v) {
        _vm.$set(_vm.getSettingsInterface, "rtvalues", $$v)
      },
      expression: "getSettingsInterface.rtvalues"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.getScreenSize > 1 || _vm.delayedLoading[1]) ? _c('el-col', {
    attrs: {
      "lg": 12
    }
  }, [_c('el-form-item', {
    staticClass: "el-form-item-full",
    attrs: {
      "label": _vm.$l('settings/interface/Language')
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": _vm.$l('common/select')
    },
    model: {
      value: (_vm.getSettingsInterface.language),
      callback: function($$v) {
        _vm.$set(_vm.getSettingsInterface, "language", $$v)
      },
      expression: "getSettingsInterface.language"
    }
  }, [_c('el-option', {
    attrs: {
      "label": _vm.$l('settings/interface/english'),
      "value": "en"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": _vm.$l('settings/interface/austria'),
      "value": "at"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": _vm.$l('settings/interface/german'),
      "value": "de"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": _vm.$l('settings/interface/french'),
      "value": "fr"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": _vm.$l('settings/interface/slovensko'),
      "value": "sl"
    }
  })], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.getScreenSize > 1 || _vm.delayedLoading[2]) ? _c('el-col', {
    attrs: {
      "lg": 12
    }
  }, [_c('el-form-item', {
    staticClass: "el-form-item-full",
    attrs: {
      "label": _vm.$l('settings/interface/Lt')
    }
  }, [_c('el-select', {
    attrs: {
      "disabled": _vm.getSettingsAddons['noise'] == 0,
      "placeholder": _vm.$l('common/select')
    },
    model: {
      value: (_vm.getSettingsInterface.RangNOtype),
      callback: function($$v) {
        _vm.$set(_vm.getSettingsInterface, "RangNOtype", $$v)
      },
      expression: "getSettingsInterface.RangNOtype"
    }
  }, [_c('el-option', {
    attrs: {
      "label": _vm.$l('settings/interface/Manual'),
      "value": "0"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": _vm.$l('settings/interface/Dynamic'),
      "value": "1"
    }
  })], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.getScreenSize > 1 || _vm.delayedLoading[3]) ? _c('el-col', {
    attrs: {
      "lg": 12
    }
  }, [_c('el-form-item', {
    staticClass: "el-form-item-full",
    attrs: {
      "label": _vm.$l('settings/interface/Manual')
    }
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 11
    }
  }, [_c('el-input-number', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "disabled": _vm.getSettingsInterface.RangNOtype == 1 || _vm.getSettingsAddons['noise'] == 0
    },
    model: {
      value: (_vm.getSettingsInterface.RangNO[0]),
      callback: function($$v) {
        _vm.$set(_vm.getSettingsInterface.RangNO, 0, $$v)
      },
      expression: "getSettingsInterface.RangNO[0]"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "line",
    attrs: {
      "span": 2
    }
  }, [_vm._v("-")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 11
    }
  }, [_c('el-input-number', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "disabled": _vm.getSettingsInterface.RangNOtype == 1 || _vm.getSettingsAddons['noise'] == 0
    },
    model: {
      value: (_vm.getSettingsInterface.RangNO[1]),
      callback: function($$v) {
        _vm.$set(_vm.getSettingsInterface.RangNO, 1, $$v)
      },
      expression: "getSettingsInterface.RangNO[1]"
    }
  })], 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.getScreenSize > 1 || _vm.delayedLoading[4]) ? _c('el-col', {
    attrs: {
      "lg": 12
    }
  }, [_c('el-form-item', {
    staticClass: "el-form-item-full",
    attrs: {
      "label": _vm.$l('settings/interface/Spectrum'),
      "placeholder": _vm.$l('common/select')
    }
  }, [_c('el-select', {
    attrs: {
      "disabled": _vm.getSettingsAddons['noise'] == 0
    },
    model: {
      value: (_vm.getSettingsInterface.RangSPtype),
      callback: function($$v) {
        _vm.$set(_vm.getSettingsInterface, "RangSPtype", $$v)
      },
      expression: "getSettingsInterface.RangSPtype"
    }
  }, [_c('el-option', {
    attrs: {
      "label": _vm.$l('settings/interface/Manual'),
      "value": "0"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": _vm.$l('settings/interface/Dynamic'),
      "value": "1"
    }
  })], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.getScreenSize > 1 || _vm.delayedLoading[5]) ? _c('el-col', {
    attrs: {
      "lg": 12
    }
  }, [_c('el-row', [_c('el-form-item', {
    staticClass: "el-form-item-full",
    attrs: {
      "label": _vm.$l('settings/interface/Manual')
    }
  }, [_c('el-col', {
    attrs: {
      "span": 11
    }
  }, [_c('el-input-number', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "disabled": _vm.getSettingsInterface.RangSPtype == 1 || _vm.getSettingsAddons['noise'] == 0
    },
    model: {
      value: (_vm.getSettingsInterface.RangSP[0]),
      callback: function($$v) {
        _vm.$set(_vm.getSettingsInterface.RangSP, 0, $$v)
      },
      expression: "getSettingsInterface.RangSP[0]"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "line",
    attrs: {
      "span": 2
    }
  }, [_vm._v("-")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 11
    }
  }, [_c('el-input-number', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "disabled": _vm.getSettingsInterface.RangSPtype == 1 || _vm.getSettingsAddons['noise'] == 0
    },
    model: {
      value: (_vm.getSettingsInterface.RangSP[1]),
      callback: function($$v) {
        _vm.$set(_vm.getSettingsInterface.RangSP, 1, $$v)
      },
      expression: "getSettingsInterface.RangSP[1]"
    }
  })], 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.getScreenSize > 1 || _vm.delayedLoading[6]) ? _c('el-col', {
    attrs: {
      "lg": 12
    }
  }, [_c('el-form-item', {
    staticClass: "el-form-item-full",
    attrs: {
      "label": _vm.$l('settings/interface/Weather')
    }
  }, [_c('el-select', {
    attrs: {
      "disabled": _vm.getSettingsAddons['weather'] == 0,
      "placeholder": _vm.$l('common/select')
    },
    model: {
      value: (_vm.getSettingsInterface.RangWEtype),
      callback: function($$v) {
        _vm.$set(_vm.getSettingsInterface, "RangWEtype", $$v)
      },
      expression: "getSettingsInterface.RangWEtype"
    }
  }, [_c('el-option', {
    attrs: {
      "label": _vm.$l('settings/interface/Manual'),
      "value": "0"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": _vm.$l('settings/interface/Dynamic'),
      "value": "1"
    }
  })], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.getScreenSize > 1 || _vm.delayedLoading[7]) ? _c('el-col', {
    attrs: {
      "lg": 12
    }
  }, [_c('el-row', [_c('el-form-item', {
    staticClass: "el-form-item-full",
    attrs: {
      "label": _vm.$l('settings/interface/Manual')
    }
  }, [_c('el-col', {
    attrs: {
      "span": 11
    }
  }, [_c('el-input-number', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "disabled": _vm.getSettingsInterface.RangWEtype == 1 || _vm.getSettingsAddons['weather'] == 0
    },
    model: {
      value: (_vm.getSettingsInterface.RangWE[0]),
      callback: function($$v) {
        _vm.$set(_vm.getSettingsInterface.RangWE, 0, $$v)
      },
      expression: "getSettingsInterface.RangWE[0]"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "line",
    attrs: {
      "span": 2
    }
  }, [_vm._v("-")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 11
    }
  }, [_c('el-input-number', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "disabled": _vm.getSettingsInterface.RangWEtype == 1 || _vm.getSettingsAddons['weather'] == 0
    },
    model: {
      value: (_vm.getSettingsInterface.RangWE[1]),
      callback: function($$v) {
        _vm.$set(_vm.getSettingsInterface.RangWE, 1, $$v)
      },
      expression: "getSettingsInterface.RangWE[1]"
    }
  })], 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.getScreenSize > 1 || _vm.delayedLoading[8]) ? _c('el-col', {
    attrs: {
      "lg": 12
    }
  }, [_c('el-form-item', {
    staticClass: "el-form-item-full",
    attrs: {
      "label": _vm.$l('settings/interface/Adio')
    }
  }, [_c('el-select', {
    attrs: {
      "disabled": _vm.getSettingsAddons['adio'] == 0,
      "placeholder": _vm.$l('common/select')
    },
    model: {
      value: (_vm.getSettingsInterface.RangADIOtype),
      callback: function($$v) {
        _vm.$set(_vm.getSettingsInterface, "RangADIOtype", $$v)
      },
      expression: "getSettingsInterface.RangADIOtype"
    }
  }, [_c('el-option', {
    attrs: {
      "label": _vm.$l('settings/interface/Manual'),
      "value": "0"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": _vm.$l('settings/interface/Dynamic'),
      "value": "1"
    }
  })], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.getScreenSize > 1 || _vm.delayedLoading[9]) ? _c('el-col', {
    attrs: {
      "lg": 12
    }
  }, [_c('el-row', [_c('el-form-item', {
    staticClass: "el-form-item-full",
    attrs: {
      "label": _vm.$l('settings/interface/Manual')
    }
  }, [_c('el-col', {
    attrs: {
      "span": 11
    }
  }, [_c('el-input-number', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "disabled": _vm.getSettingsInterface.RangADIOtype == 1 || _vm.getSettingsAddons['adio'] == 0
    },
    model: {
      value: (_vm.getSettingsInterface.RangADIO[0]),
      callback: function($$v) {
        _vm.$set(_vm.getSettingsInterface.RangADIO, 0, $$v)
      },
      expression: "getSettingsInterface.RangADIO[0]"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "line",
    attrs: {
      "span": 2
    }
  }, [_vm._v("-")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 11
    }
  }, [_c('el-input-number', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "disabled": _vm.getSettingsInterface.RangADIOtype == 1 || _vm.getSettingsAddons['adio'] == 0
    },
    model: {
      value: (_vm.getSettingsInterface.RangADIO[1]),
      callback: function($$v) {
        _vm.$set(_vm.getSettingsInterface.RangADIO, 1, $$v)
      },
      expression: "getSettingsInterface.RangADIO[1]"
    }
  })], 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.getScreenSize > 1 || _vm.delayedLoading[10]) ? _c('el-col', {
    attrs: {
      "lg": 12
    }
  }, [_c('el-row', [_c('el-form-item', {
    staticClass: "el-form-item-full",
    attrs: {
      "label": _vm.$l('settings/interface/noiseTriggerLevel')
    }
  }, [_c('el-switch', {
    model: {
      value: (_vm.getSettingsInterface.showNoiseTriggerLevel),
      callback: function($$v) {
        _vm.$set(_vm.getSettingsInterface, "showNoiseTriggerLevel", $$v)
      },
      expression: "getSettingsInterface.showNoiseTriggerLevel"
    }
  })], 1)], 1)], 1) : _vm._e()], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-adf2cc66","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/settings/categories/Interface.vue
// module id = 476
// module chunks = 1